import React from "react";
import { FooterWrapper } from "./footer.style";
import { Link } from "react-router-dom";
import "../../App.css";
const Footer = () => {
  return (
    <FooterWrapper>
      <div className="lg-recoov-footer-container">
        <div className="lg-recoov-newsletter ">
          <div className="lg-recoov-newsletter-box-title">
            <h4 className="lg-recoov-newsletter-title">
              Laissez nous un message
            </h4>
          </div>
          {/* <form action="" className="lg-recoov-newsletter-form">
            <div className="lg-recoov-newsletter-form-content"> */}
          {/* <input
                type="text"
                placeholder="Entrez votre e-mail"
                className="lg-recoov-newsletter-form-input"
              /> */}
          <Link to="https://share.hsforms.com/1SXK4l2SzQhO01C8yoFWafA32gu0">
            <button className="text-white px-10 py-3  hover:bg-green-700 bg-green-600 rounded-lg transition duration-300 ease-in-out">
              Contacter
            </button>
          </Link>
          {/* </div> */}
        {/* </form> */}
        </div>
        <div className="my-12">
          <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-8 lg:gap-12">
            {/* Logo and Description Section */}
            <div className="lg:max-w-md">
              <div className="lg-recoov-footer-logo-box mb-4">
                <a
                  className="lg-recoov-footer-logo inline-block"
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src="/assets/images/logo-recoov.png"
                    loading="lazy"
                    width={100}
                    height="auto"
                    alt="logo de Datagreffe"
                    className="h-auto"
                  />
                </a>
              </div>
              <div className="lg-recoov-footer-text-box">
                <p className="lg-recoov-footer-text text-gray-600 leading-relaxed">
                  Accédez à toutes les informations légales, juridiques et
                  financières sur les entreprises ivoiriennes en quelques clics.
                </p>
              </div>
            </div>

            {/* Links Section - Grid layout for responsive design */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 lg:gap-12 flex-1 lg:max-w-2xl">
              {/* Services Column */}
              <div>
                <h3 className="font-medium text-gray-900 mb-3 text-lg">
                  Services
                </h3>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/services"
                      className="text-gray-600 hover:text-primary transition-colors duration-200 text-sm"
                    >
                      Annonces légales
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/formalite"
                      className="text-gray-600 hover:text-primary transition-colors duration-200 text-sm"
                    >
                      Formalités
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/services"
                      className="text-gray-600 hover:text-primary transition-colors duration-200 text-sm"
                    >
                      Documents légaux
                    </Link>
                  </li>
                </ul>
              </div>

              {/* À propos Column */}
              <div>
                <h3 className="font-medium text-gray-900 mb-3 text-lg">
                  À propos
                </h3>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/about"
                      className="text-gray-600 hover:text-primary transition-colors duration-200 text-sm"
                    >
                      Notre mission
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="https://share.hsforms.com/1SXK4l2SzQhO01C8yoFWafA32gu0"
                      className="text-gray-600 hover:text-primary transition-colors duration-200 text-sm"
                    >
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/recrutement"
                      className="text-gray-600 hover:text-primary transition-colors duration-200 text-sm"
                    >
                      Recrutement
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Informations Column */}
              <div>
                <h3 className="font-medium text-gray-900 mb-3 text-lg">
                  Informations
                </h3>
                <ul className="space-y-2">
                  <li>
                    <Link
                      to="/faq"
                      className="text-gray-600 hover:text-primary transition-colors duration-200 text-sm"
                    >
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/mentions-legales"
                      className="text-gray-600 hover:text-primary transition-colors duration-200 text-sm"
                    >
                      Mentions légales
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/privacy"
                      className="text-gray-600 hover:text-primary transition-colors duration-200 text-sm"
                    >
                      Données personnelles
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm mb-4 md:mb-0">
            © {new Date().getFullYear()} Datagreffe. Tous droits réservés.
          </p>
          <div className="flex space-x-4">
            <Link to="/" className="text-gray-400 hover:text-gray-500">
              <span className="sr-only">LinkedIn</span>
              <svg
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                  clipRule="evenodd"
                />
              </svg>
            </Link>
            <Link to="/" className="text-gray-400 hover:text-gray-500">
              <span className="sr-only">Facebook</span>
              <svg
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M22 12c0-5.523-4.477-10-10-10s-10 4.477-10 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54v-2.891h2.54v-2.203c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562v1.875h2.773l-.443 2.891h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                  clipRule="evenodd"
                />
              </svg>
            </Link>
            <Link to="/" className="text-gray-400 hover:text-gray-500">
              <span className="sr-only">Twitter</span>
              <svg
                className="h-6 w-6"
                fill="currentColor"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
              </svg>
            </Link>
          </div>
        </div>
      </div>
      <div className="bg-white p-2"></div>
    </FooterWrapper>
  );
};

export default Footer;
